<template>
  <div class="dialog_container">
    <v-card class="elevation-0">
      <v-card-title>
        <span>To customize your experience, tell us who you are.</span>
        <v-layout>
          <v-flex xs6 pa-3 text-xs-center @click="roleDidClick('teacher')" style="cursor: pointer">
            <v-btn block large secondary>Teacher</v-btn>
          </v-flex>
          <v-flex xs6 pa-3 text-xs-center @click="roleDidClick('student')" style="cursor: pointer">
            <v-btn block large secondary>Student</v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    roleDidClick(role) {
      this.$store.dispatch('setRole', role)

      this.$emit("closeDialog")
    }
  },
  mounted() {
  },
};
</script>

<style scoped>
</style>
